import { Component, OnInit, Input } from '@angular/core';
import { SavingInvestmentAddEditComponent } from './parts/add-edit/add-edit.component';

@Component({
  selector: 'app-saving-investment',
  templateUrl: './saving-investment.component.html',
  styleUrls: ['./saving-investment.component.scss']
})
export class SavingInvestmentComponent implements OnInit {

  @Input() object: Object;
  @Input() summaryOnly: boolean = false;
  public key: string;
  public extraData: Object;

  constructor() { }

  ngOnInit(): void {

    this.key = 'saving-investment';
    this.extraData = {
      heading: this.object['title']['rendered'],
      component: SavingInvestmentAddEditComponent,
      showSummaryOnly: this.showSummaryOnly(),
      options: {
        class: 'modal-lg'
      },
      section: {
        key: 'saving-investment',
        title: 'Savings & Investments',
        type: 'children',
        childType: 'saving-investment',
        plural: 'savings and investments',
        singular: 'Saving or investment',
        min: 0,
        max: 0,
      },
    }

  }

  showSummaryOnly() {

    if( typeof( this.object ) === 'undefined' ) {
      return true;
    }

    return this.summaryOnly;

  }

}
